import { datadogRum } from '@datadog/browser-rum';
import fetch from 'Utils/httpClients/httpClient';
import { getCustomerLendingProfileDomain } from './httpUtils';

const fetchCustomerLendingProfile = async (url, method, data, otherHeaders) => {
  const domain = getCustomerLendingProfileDomain();

  const headers = {
    ...otherHeaders,
    Authorization: `Bearer ${localStorage.kueski_session}`,
  };

  // eslint-disable-next-line camelcase
  const sessionID = datadogRum?.getInternalContext()?.session_id;
  const customerID = window?.DD_LOGS?.getLoggerGlobalContext()?.view?.data?.customer.id;
  if (sessionID) headers['injected-session-id'] = sessionID;
  if (customerID) headers['injected-customer-id'] = customerID;

  try {
    const response = await fetch(`${url}`, {
      baseURL: domain, data, headers, method,
    });
    if (response && response.data && response.data.status === 'fail') {
      // eslint-disable-next-line no-throw-literal
      throw {
        response,
      };
    }

    return response.data;
  } catch (error) {
    const { response } = error;

    if (response && response.data && response.data.status === 'fail') {
      throw response;
    } else {
      throw error;
    }
  }
};

export default fetchCustomerLendingProfile;
